<div class="w-screen h-screen" id="app"><router-view></router-view></div>